<template>
  <v-container grid-list-md text-center v-if="isConfigLoaded">
    <v-card class="mx-auto" elevation="0">
      <v-window v-model="step">
        <!--SELECT CONTENT-->
        <v-window-item :value="1">
          <v-card class="mx-auto" elevation="0">
            <h2 class="text-xs-center">
              <span v-html="this.getConfigItem('HOW_CAN_WE_TEXT')"></span>
            </h2>
            <v-list v-if="!isShowNoData">
              <!-- LIST TITLES -->
              <h4 class="text-xs-center">
                {{ this.getConfigItem("SELECTION_TEXT") }}
              </h4>

              <v-list-item
                v-if="isShowListHeader"
                class="primary--text"
                style="
                  margin: 16px;
                  margin-bottom: 0px;
                  margin-top: 0px;
                  height: 40px;
                "
              >
                <v-list-item-content>
                  <v-list-item-title v-text="unitTitle"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_COUNT', true)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="primary--text" v-on="on">
                        mdi-format-list-numbered
                      </v-icon>
                    </template>
                    <span>
                      {{ this.getConfigItem("TTIP_TICKET_QUEUE_TEXT") }}
                    </span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  v-if="this.getConfigItem('SHOW_WAIT_TIMES', true)"
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="primary--text" v-on="on">
                        mdi-clock
                      </v-icon>
                    </template>
                    <span>
                      {{ this.getConfigItem("TTIP_AVG_TIME_TEXT") }}
                    </span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>

              <!-- LIST FOR CONTENTS -->
              <v-list-item
                v-for="content in contents"
                :key="content.Id"
                @click="onSelectContent(content)"
                :style="{ 'background-color': SECONDARY_COLOUR }"
                style="margin: 16px"
              >
                <v-list-item-content
                  v-if="getConfigItem('LEFT_ALIGNED_LIST_ITEM')"
                >
                  <v-list-item-title
                    :style="[{ color: SECONDARY_COLOUR_TEXT }]"
                    class="text-center"
                    v-text="content.Name"
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title
                    :style="[
                      { color: SECONDARY_COLOUR_TEXT },
                      { 'text-align': 'center !important' },
                    ]"
                    class="text-center"
                    v-text="content.Name"
                  ></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar
                  tile
                  v-if="
                    content.ServiceId && getConfigItem('SHOW_WAIT_COUNT', true)
                  "
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label color="white" class="ml-0">
                        {{ content.WaitCount }}
                      </v-chip>
                    </template>
                    <span> {{ getConfigItem("TTIP_TICKET_QUEUE_TEXT") }} </span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-avatar
                  tile
                  v-if="
                    content.ServiceId && getConfigItem('SHOW_WAIT_TIMES', true)
                  "
                  min-width="70"
                  max-width="100"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip v-on="on" label color="white" class="ml-0">
                        {{
                          content.WaitTimeAvg
                            | getShortFormattedWaitTimeFromSeconds
                        }}
                      </v-chip>
                    </template>
                    <span>{{ getConfigItem("TTIP_AVG_TIME_TEXT") }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
              </v-list-item>
            </v-list>

            <!-- Nothing available -->
            <div v-if="isShowNoData">
              <h3 class="text-xs-center">
                {{ this.getConfigItem("NO_SERVICE_TEXT") }}
              </h3>
            </div>

            <!-- Back button -->
            <v-row row wrap>
              <v-col xs12 class="text-xs-center">
                <v-btn
                  :style="[
                    { color: this.getConfigItem('INFO_COLOUR_TEXT') },
                    {
                      'background-color': this.getConfigItem(
                        'BTN_BACKGROUND_COLOUR'
                      ),
                    },
                  ]"
                  color="info"
                  @click="stepBack()"
                  >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                >
              </v-col>
            </v-row>

            <!-- Bottom legend -->
            <div
              v-if="isShowListLegend"
              row
              wrap
              style="margin: 16px; background-color: #f3f3f3; padding: 16px"
              text-left
            >
              <v-row
                style="width: 100%; padding-left: 12px"
                v-if="this.getConfigItem('SHOW_WAIT_COUNT', true)"
              >
                <v-icon class="primary--text" small>
                  mdi-format-list-numbered
                </v-icon>
                <span style="font-size: 10px; padding-left: 5px">
                  {{ this.getConfigItem("TICKETS_INQUEUE_TEXT") }}
                </span>
              </v-row>
              <v-row
                style="width: 100%; padding-left: 12px"
                v-if="this.getConfigItem('SHOW_WAIT_TIMES', true)"
              >
                <v-icon class="primary--text" small>mdi-clock</v-icon>
                <span style="font-size: 10px; padding-left: 5px">
                  {{ this.getConfigItem("AVG_TIME_TEXT") }}
                </span>
              </v-row>
            </div>
          </v-card>
        </v-window-item>

        <!--MOBILE NUMBER-->
        <v-window-item :value="2">
          <v-card class="mx-auto" elevation="0">
            <h2 class="text-xs-center">
              {{ this.getConfigItem("ENTER_MOBILE_INFO_TEXT") }}
            </h2>
            <v-form
              ref="phoneForm"
              v-model="isPhonenumValid"
              lazy-validation
              @submit.prevent="confirmMobile()"
              id="confirmMobileForm"
            >
              <v-text-field
                v-model="inputPhonenum"
                type="number"
                :label="this.getConfigItem('PHOLDER_INPUTHERE_TEXT')"
                required
                :rules="phonenumRules"
                :hint="this.getConfigItem('MOBILENUM_HINT_TEXT')"
              ></v-text-field>
              <v-row row wrap>
                <v-col xs12 class="text-xs-center">
                  <v-btn
                    color="secondary"
                    :style="{
                      color: this.SECONDARY_COLOUR_TEXT,
                    }"
                    class="ma-3"
                    @click="stepBack()"
                    >{{ this.getConfigItem("BTN_BACK_TEXT") }}</v-btn
                  >
                  <v-btn
                    type="submit"
                    class="ma-3"
                    color="primary"
                    :style="{ color: this.PRIMARY_COLOUR_TEXT }"
                    >{{ this.getConfigItem("BTN_CONTINUE_TEXT") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
import cookieMixin from "@/mixins/cookieMixin";
import configAliasMixin from "@/mixins/configAliasMixin";
import serviceMixin from "@/mixins/serviceMixin";
import utilMixin from "@/mixins/utilMixin";
import enqueueCommonMixin from "@/mixins/enqueueCommonMixin";
import { mapGetters } from "vuex";
import { helper } from "@/helper";

export default {
  mixins: [
    configAliasMixin,
    cookieMixin,
    serviceMixin,
    utilMixin,
    enqueueCommonMixin,
  ],
  data: function () {
    return {
      step: 1,

      contentHistory: [{ Id: 0 }],
      contents: [],
      selectedContent: null,
      classifications: [],
      selectedService: null,
      currentContentIndex: 0,

      isMobileConfirmed: false,
      isClickedLastStep: false,

      isPhonenumValid: false,
      inputPhonenum: "",
      phonenumRules: [],

      isShowListHeader: true,
      listHeader: [{}],
      unitTitle: "",

      isForward: true,
    };
  },
  watch: {
    isConfigLoaded() {
      if (this.isConfigLoaded) {
        this.phonenumRules = [
          (v) => !!v || this.getConfigItem("REQUIRED_TEXT"),
          (v) => /^04/.test(v) || this.getConfigItem("PHONE_MUST_START_TEXT"),
          (v) =>
            (v || "").length >= 10 ||
            this.getConfigItem("PHONE_MUST_EQUAL_TEXT"),
          (v) =>
            /^\d{1,10}$/.test(v) || this.getConfigItem("PHONE_MAX_NUMBER_TEXT"),
        ];
      }
    },
  },
  mounted: function () {
    let userCookie = helper.getUserCookie();

    if (userCookie && this.validatePhonenum(userCookie.mobile)) {
      this.inputPhonenum = userCookie.mobile;
    }
    if (this.isConfigLoaded) {
      this.phonenumRules = [
        (v) => !!v || this.getConfigItem("REQUIRED_TEXT"),
        (v) => /^04/.test(v) || this.getConfigItem("PHONE_MUST_START_TEXT"),
        (v) =>
          (v || "").length >= 10 || this.getConfigItem("PHONE_MUST_EQUAL_TEXT"),
        (v) =>
          /^\d{1,10}$/.test(v) || this.getConfigItem("PHONE_MAX_NUMBER_TEXT"),
      ];
      this.loadContents();
    }
  },
  methods: {
    loadContents() {
      this.selectedContent = this.contentHistory[this.currentContentIndex];
      let self = this;
      let loadingMessage = self.getConfigItem("LOAD_CONTENTS_TEXT");

      this.callGetService(
        this,
        "/Menu/Content/" + self.selectedContent.Id,
        null,
        (response) => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log(
              "in EnqueueContent.loadContents() response",
              response.data
            );
          self.contents = response.data;
          self.isShowListHeader = self.getConfigItem("SHOW_LIST_HEADER", true);
        },
        null,
        loadingMessage
      );
    },
    onSelectContent(content) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("onSelectContent", content);

      if (content.ServiceId) {
        this.onSelectService(content);
      } else {
        this.onSelectSubContent(content);
      }
    },
    onSelectSubContent(item) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("onSelectSubContent", item);
      this.selectedContent = item;
      this.contentHistory.push(this.selectedContent);
      this.currentContentIndex++;
      this.loadContents();
    },
    onSelectService(item) {
      this.selectedService = item;

      if (
        this.isMobileConfirmed ||
        this.getConfigItem("SKIP_MOBILE_CONF", true)
      ) {
        this.submitRequest();
        return;
      }

      if (item != null) {
        this.step = 2;
      }
    },

    stepBack() {
      this.isForward = false;
      if (this.step > 1) {
        this.step--;
        return;
      }

      this.contentHistory.pop();
      this.currentContentIndex--;

      if (this.contentHistory.length <= 0) {
        this.$router.push("/");
      } else {
        this.loadContents();
      }
    },
    submitRequest() {
      if (process.env.VUE_APP_ISDEBUGGING) console.log("submitRequest()");
      if (!this.isClickedLastStep) {
        this.isClickedLastStep = true;
        if (
          this.$refs.phoneForm != null &&
          !this.$refs.phoneForm.validate() &&
          !this.isMobileConfirmed &&
          !this.getConfigItem("SKIP_MOBILE_CONF", true)
        ) {
          return;
        }

        let userCookie = helper.getUserCookie();
        // SUBJECT & EXT REF TEMPLATE --------------------------------------------------
        let valueObj = {};
        valueObj.personalId =
          userCookie && userCookie.userName ? userCookie.userName : "";
        valueObj.mobile = this.phonenum ? this.phonenum : "";
        valueObj.name = this.fullName ? this.fullName : "";
        valueObj.classification = this.selectedClassification
          ? this.selectedClassification.Name
          : "";

        let subject = this.getConfigItem("SUBJECT_TEMPLATE");
        subject = this.updateTemplate(subject, valueObj);

        if (this.getConfigItem("SUBJECT_REMOVEBLANKS", true)) {
          subject = subject.split("[]").join("");
        }

        let extRef = this.getConfigItem("EXTREF_TEMPLATE");
        // console.log("extRef1:", extRef);
        extRef = this.updateTemplate(extRef, valueObj);
        // console.log("extRef2:", extRef);
        extRef = "";
        //------------------------------------------------------------------------------

        let emailAddress =
          userCookie && userCookie.email ? userCookie.email : "";
        if (emailAddress == "" && userCookie && userCookie.emailAddress)
          emailAddress = userCookie.emailAddress;

        let customProperties = this.getCustomProperties();

        let postParam = {
          ServiceId: this.selectedService.ServiceId,
          ExtRef: extRef,
          Notes: "",
          Subject: subject,
          CustomProperties: customProperties,
        };

        if (this.getConfigItem("USE_CUSTOMER_RECORD", true)) {
          this.postQueueWithCustomerId(postParam);
        } else {
          this.postQueue(postParam, valueObj.classification);
        }
      }
    },
    postQueueWithCustomerId(postParam, classificationStr) {
      let customerParam = {
        IsActive: true,
        CustomProperties: {},
      };

      let userCookie = helper.getUserCookie();
      customerParam.PersonalId = userCookie.studentId
        ? userCookie.studentId
        : userCookie.mobile;
      if (userCookie.firstName) customerParam.FirstName = userCookie.firstName;
      if (userCookie.lastName) customerParam.LastName = userCookie.lastName;
      if (userCookie.email) customerParam.Email = userCookie.email;
      if (userCookie.mobile) customerParam.TelNumber1 = userCookie.mobile;

      let loadingMessage = this.getConfigItem("REQUEST_TICKET_TEXT");
      this.callPostService(
        this,
        "/Customers",
        customerParam,
        (response) => {
          if (response.status == 200) {
            // OK - not created new
            this.$store.commit("existingTicket", true);
          }
          let data = response.data;

          postParam.CustomerId = data.CustomerId;

          this.postQueue(postParam, classificationStr);
        },
        null,
        loadingMessage
      );
    },
    postQueue(postParam, classificationStr) {
      let loadingMessage = this.getConfigItem("REQUEST_TICKET_TEXT");

      let self = this;
      // console.log("post queue before callpost service: ", loadingMessage);
      // console.log("self: ", self);
      // console.log("postParam: ", postParam);
      this.callPostService(
        this,
        "/Cases",
        postParam,
        (response) => {
          if (response.status == 200) {
            // OK - not created new
            this.$store.commit("existingTicket", true);
          }
          let data = response.data;

          if (data.CaseId) {
            helper.setCaseCookie(
              data.CaseId,
              false,
              "",
              classificationStr,
              this.getConfigItem("DATA_RETENTION_PERIOD")
            );
            this.$router.push("EnqueueInfo");
          }
        },
        (err) => {
          self.contents = []; // this will show "no service" message
          self.step = 1;
          console.log("err:", err);
          console.log(err.response); // TODO: Do proper logging
        },
        loadingMessage
      );
    },
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    isShowNoData() {
      return this.contents.length == 0;
    },
  },
};
</script>
